import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@raketa-cms/raketa-cms';
import { Parallax } from 'react-scroll-parallax';

import ParallaxImage from '../ParallaxImage';

const PaSectionWidget = ({ link, title, text, portrait_left_img, landscape_right_img, containerSettings }) => (
  <Container settings={containerSettings}>
    <div className="parallax">
      <a href={link} className="parallax-box pa-section">
        <div className="portrait-image-mask">
          <Parallax
            offsetXMin={400}
            offsetXMax={-100}
            slowerScrollRate
            tag="figure"
          >
            <div style={{ width: '800px', height: '900px', backgroundColor: 'rgba(242,182,50,.6)' }} />
          </Parallax>
        </div>

        <div className="portrait-image">
          <Parallax
            offsetYMin={-30}
            offsetYMax={30}
            slowerScrollRate
            tag="figure"
          >
            <ParallaxImage src={portrait_left_img} variant="parallax_portrait_left" />
          </Parallax>
        </div>

        <div className="landscape-image-mask">
          <Parallax
            offsetXMin={-100}
            offsetXMax={200}
            slowerScrollRate
            tag="figure"
          >
            <div style={{ width: '1600px', height: '900px', backgroundColor: 'rgba(0,0,0,.8)' }} />
          </Parallax>
        </div>

        <div className="landscape-image">
          <Parallax
            offsetYMin={-30}
            offsetYMax={30}
            slowerScrollRate
            tag="figure"
          >
            <ParallaxImage src={landscape_right_img} variant="parallax_landscape_right" />
            <ParallaxImage src={landscape_right_img} variant="parallax_landscape_right_mobile" />
          </Parallax>
        </div>

        <div className="letter-bg"></div>

        <Parallax
          className="title"
          offsetYMin={-10}
          offsetYMax={1000}
          tag="div"
        >
          <h1>{title}</h1>
        </Parallax>

        <Parallax
          className="letter"
          offsetYMin={-10}
          offsetYMax={1000}
          tag="div"
        >
          <div className="letter-wrapper pa">
            <img src="data:image/svg+xml;base64,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" />
          </div>
        </Parallax>

        <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
      </a>
    </div>
  </Container>
);

PaSectionWidget.title = 'PA Section';
PaSectionWidget.category = 'Parallax Homepage';

PaSectionWidget.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  portrait_left_img: PropTypes.any.isRequired,
  landscape_right_img: PropTypes.any.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

PaSectionWidget.defaults = {
  link: '#',
  title: 'Title',
  text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta quibusdam eius voluptate repudiandae odio aut, ea voluptas. In consectetur praesentium minus molestiae fuga hic? Tempore consequuntur debitis maiores laudantium aliquid.',
  portrait_left_img: 'http://via.placeholder.com/560x630',
  landscape_right_img: 'http://via.placeholder.com/1120x630',
  containerSettings: {},
};

PaSectionWidget.adminFields = {
  portrait_left_img: { type: 'image' },
  landscape_right_img: { type: 'image' },
  link: { type: 'text' },
  title: { type: 'text' },
  text: { type: 'rich' },
};

export default PaSectionWidget;
